import React from 'react';
import MUIAlert from '../shared/mui-alert';
import calculateLicenseRequirements from './utils/license-calculations';
import { Row } from './add-member-row';
import { Membership } from '../models/member';

interface LicenseRequirementAlertProps {
  members: (Row | Membership)[];
  availableLicenses: number;
  minimumLicensePurchase?: number;
}

/**
 * Displays an alert when new licenses will be required for adding members
 * Also shows minimum purchase warning when applicable
 */
export default function LicenseRequirementAlert({
  members,
  availableLicenses,
  minimumLicensePurchase,
}: LicenseRequirementAlertProps) {
  const { newLicensesRequired, licensesToPurchase } = calculateLicenseRequirements(
    members,
    availableLicenses,
    minimumLicensePurchase,
  );

  if (newLicensesRequired === 0) {
    return null;
  }

  return (
    <MUIAlert severity="info">
      <strong>{licensesToPurchase}</strong>
      {' '}
      New licenses will be required.
      {minimumLicensePurchase && minimumLicensePurchase > 1 && (
        <>
          {' '}
          As per your contract, there is a
          {' '}
          <strong>
            {minimumLicensePurchase}
            -license minimum purchase
          </strong>
          .
        </>
      )}
    </MUIAlert>
  );
}
